import React from 'react';

const Fields = (props)=>{
    const {field} = props;    

    return(
        <div className='col-xs-12 col-sm-4 form-group'>
            <div className='col-xs-12 col-md-8'>
                <span className='size-min'>{field.label}</span>
            </div>
            <div className='col-xs-12 col-md-4'>
                {field.type_name === 'Combo' || field.type_name === 'ComboSiNo' ?
                    <select className='form-control' name={field.field_id} id={field.field_id} value={field.default_value}
                        onChange={(e)=>props.updateForm(e, props.section, props.index)}>
                        <option value="">Seleccione...</option>
                        {field.options.map((opt, i)=>
                            <option key={i} value={opt.Valor}>{opt.Text}</option>
                        )}
                    </select>
                : 
                    <input 
                        className='form-control' 
                        type={
                            field.type_name === 'Numerico' ? 'number' :
                            field.type_name === 'Fecha' ? 'date' :
                            'text'
                        } 
                        name={field.field_id} id={field.field_id} 
                        value={field.default_value || ""}
                        onChange={(e)=>props.updateForm(e, props.section, props.index)}
                    />
                }
            </div>
        </div>
    )
}

export default Fields;